<div style="padding: 16px">
  @if (promptitLataa()) {
    <mat-spinner diameter="32"></mat-spinner>
  } @else {
    <div style="display: flex; gap: 12px; align-items: center; margin-bottom: 16px; flex-wrap: wrap">
      @if (promptit().length > 0) {
        <mat-form-field style="width: 360px; margin-bottom: -1.25em" subscriptSizing="dynamic">
          <mat-label>Prompti</mat-label>
          <mat-select [formField]="promptiValinta" (selectionChange)="valitsePrompti($event.value)" [compareWith]="vertaaPromptit">
            @for (p of promptit(); track p.promptiId) {
              <mat-option [value]="p.promptiId">{{ p.nimi }}</mat-option>
            }
          </mat-select>
        </mat-form-field>
      }
      <button mat-stroked-button (click)="avaaLuontiDialog()">
        <mat-icon>add</mat-icon>
        Luo uusi prompti
      </button>
    </div>

    @if (valittuPrompti()) {
      <div style="font-size: 12px; color: #666; margin-bottom: 8px">
        Aktiivinen versio: <strong>v{{ valittuPrompti().versio }}</strong> — päivitetty {{ valittuPrompti().paivitetty | date: 'dd.MM.yyyy HH:mm' }}
        @if (valittuPrompti().paivittajaUid) {
          <span> ({{ annaPaivittajanNimi(valittuPrompti().paivittajaUid) }})</span>
        }
      </div>

      <mat-form-field style="width: 100%; max-width: 600px">
        <mat-label>Nimi</mat-label>
        <input matInput [formField]="lomake.nimi" />
      </mat-form-field>

      <p style="font-size: 12px; color: #666; max-width: 800px; margin: 4px 0 8px 0">JSON-vastauksen rakenne (kentät ja arvot) on kovakoodattu palveluun. Muokkaa tässä vain ohje-osaa.</p>

      <mat-form-field style="width: 100%">
        <mat-label>Prompti</mat-label>
        <textarea matInput [formField]="lomake.sisalto" style="font-family: monospace; font-size: 12px; min-height: 300px; resize: vertical"></textarea>
      </mat-form-field>

      <div style="display: flex; gap: 8px; margin-top: 8px; flex-wrap: wrap">
        <button mat-raised-button color="primary" (click)="tallenna()" [disabled]="tallennetaan() || !lomake.nimi().value().trim() || !lomake.sisalto().value().trim()">
          @if (tallennetaan()) {
            <mat-spinner diameter="18" style="display: inline-block; margin-right: 8px"></mat-spinner>
          }
          Tallenna uusi versio
        </button>
        <button mat-button color="warn" (click)="poistaVahvistuksella()" [disabled]="poistetaan()">
          <mat-icon>delete</mat-icon>
          Poista
        </button>
        <button mat-button (click)="toggleHistoria()">
          <mat-icon>{{ naytaHistoria() ? 'expand_less' : 'expand_more' }}</mat-icon>
          Versiohistoria
        </button>
        <button mat-button (click)="toggleNaytaKokoPrompt()" [disabled]="!jsonKontrakti()">
          <mat-icon>{{ naytaKokoPrompt() ? 'expand_less' : 'expand_more' }}</mat-icon>
          Näytä koko system prompt
        </button>
      </div>

      @if (naytaKokoPrompt()) {
        <div style="margin-top: 16px; padding: 12px; background: #fafafa; border: 1px solid #ddd; border-radius: 4px">
          <div style="font-size: 12px; color: #666; margin-bottom: 6px">Tämä on LLM:lle lähetettävä kokonaisuus: kovakoodattu vastausrakenne (yltä) + muokattava ohje-osa (alta). Päivittyy reaaliajassa kun muokkaat sisältöä.</div>
          <pre style="background: #fff; border: 1px solid #ddd; padding: 10px; font-size: 11px; white-space: pre-wrap; word-break: break-word; max-height: 500px; overflow-y: auto; margin: 0">{{ kokoSystemPrompt }}</pre>
        </div>
      }

      @if (naytaHistoria()) {
        <div style="margin-top: 16px">
          @if (historiaLataa()) {
            <mat-spinner diameter="24"></mat-spinner>
          } @else if (historia().length > 1) {
            <table style="width: 100%; font-size: 12px; border-collapse: collapse">
              <tr style="background: #f5f5f5">
                <th style="text-align: left; padding: 6px">Versio</th>
                <th style="text-align: left; padding: 6px">Päivitetty</th>
                <th style="text-align: left; padding: 6px">Päivittäjä</th>
                <th style="text-align: left; padding: 6px">Esikatselu</th>
                <th style="padding: 6px"></th>
              </tr>
              @for (v of historia(); track v.versio) {
                <tr style="border-bottom: 1px solid #eee">
                  <td style="padding: 6px; font-family: monospace">v{{ v.versio }}</td>
                  <td style="padding: 6px">{{ v.paivitetty | date: 'dd.MM.yyyy HH:mm' }}</td>
                  <td style="padding: 6px">{{ annaPaivittajanNimi(v.paivittajaUid) }}</td>
                  <td style="padding: 6px; max-width: 400px; overflow: hidden; text-overflow: ellipsis; white-space: nowrap">{{ v.sisalto | slice: 0 : 80 }}{{ v.sisalto.length > 80 ? '…' : '' }}</td>
                  <td style="padding: 6px">
                    <button mat-button (click)="esikatsele(v)">Näytä</button>
                    <button mat-button color="primary" (click)="palautaVersio(v.versio)">Palauta</button>
                  </td>
                </tr>
              }
            </table>
          } @else {
            <p style="color: #888; font-size: 12px; margin: 0">Ei aiempia versioita.</p>
          }
        </div>
      }

      @if (esikatseluVertailu()) {
        <app-prompti-versiovertailu [vertailu]="esikatseluVertailu()" (palauta)="palautaVersio($event)" (sulje)="suljeEsikatselu()"></app-prompti-versiovertailu>
      }
    } @else {
      <p style="color: #888; font-size: 13px; margin-top: 16px">Ei aktiivisia promptteja. Luo uusi prompti yltä.</p>
    }
  }
</div>
